// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1IOgJ","label":"Completed_label__2v3hE"};